import {types as t} from 'mobx-state-tree';
import {get} from 'lodash';
import {AbstractTestSection} from '../../question-data-model/TestSection/abstract-test-section.store';
import {TestQuestionGroupStore} from '../../student-do-test/model/test-question-group.store';

export const ViewTestSubjectTestSectionStore = AbstractTestSection.named('TestSectionStore')
  .props({
    questionGroups: t.array(TestQuestionGroupStore),
  })
  .views((self) => ({
    get totalQuestionInGroup() {
      let count = 0;
      self.questionGroups.forEach((group) => {
        count += get(group, 'questionCount', 0);
      });
      return count;
    },
    get totalAnswerInGroup() {
      let count = 0;
      self.questionGroups.forEach((group) => {
        count += get(group, 'answerCount', 0);
      });
      return count;
    },
    getQuestions() {
      const questions = [];
      self.questionGroups.forEach((group: any) => {
        questions.push(...group.questions);
      });
      return questions;
    },
  }));

